import Vue from 'vue'
import router from './router'
import App from './App.vue'
import Ajax from './js/Ajax'
import Config from './js/Config'
import Tool from './js/Tool';
import Wxtool from './js/WxTool';

Vue.config.productionTip = false
Vue.prototype.Ajax = Ajax
Vue.prototype.$config = Config
Vue.prototype.$tool = Tool
Vue.prototype.$wxtool = Wxtool

var vue = new Vue({
  el: '#app',
  router,
  render: h => h(App)
})

router.beforeEach((to, form, next) => {
  //重置按键事件

  next()
})


export default vue;